export { default } from './components/spinner';
